@if (isVerticalLayoutRequested()) {
  <app-main-layout />
}
@if (isHorizontalLayoutRequested()) {
  <horizontal-layout />
}
